
/**
 * @export
 * @enum {string}
 */
export enum SystemEventSource {
    PLATFORM = 'PLATFORM',
    RTS = 'RTS',
    SURVEY = 'SURVEY',
    UDMP = 'UDMP',
    RAG = 'RAG'
}